import React,{useState, useEffect}  from 'react';
import Table from 'react-bootstrap/Table'
import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Ckeyword(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      
      <Helmet>
 
 <title>Learn Free JavaScript Keywords Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript Keywords tutorial for beginners.In Javascript there are 77 keywords CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript Keywords,Javascript Keywords for,javascript keyword,javascript keyword this,javascript keywords,javascript keyboard event listener,javascript keyword this,javascript static keyword,javascript keyword list" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-keyword" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Javascript keyword</h1>
    <div className="first">
        <a href="/javascript-variables">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-comment">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">
1, Javascript keywords cannot be used as identifiers<br/>
2, They cannot use as names for a variable, class, or method.<br/>
3, Javascript Programming keywords are Known as Reserved Words.

</p>
<h2 className="mt-4 mh2">Javascript keyword programming table</h2>
    <Table responsive striped bordered hover variant="dark m-3">
 
 <tbody>
   <tr>
     
     <td>await</td>
     <td>break</td>
     <td>case</td>
     <td>catch</td>
     <td>class</td>
     <td>const</td>
     <td>continue</td>
     <td>debugger</td>
   </tr>
   <tr>
    
     <td>default</td>
     <td>delete</td>
     <td>do</td>
     <td>else</td>
     <td>enum</td>
     <td>export</td>
     <td>extends</td>
     <td>false</td>
   </tr>
   <tr>
   
     <td>finally</td>
     <td>for</td>
     <td>function</td>
     <td>if</td>
     <td>implements</td>
     <td>import</td>
     <td>in</td>
     <td>instanceof</td>
    
   </tr>

   <tr>
   
     <td>interface</td>
     <td>let</td>
     <td>new</td>
     <td>null</td>
     <td>package</td>
     <td>private</td>
     <td>protected</td>
     <td>public</td>
   </tr>

   <tr>
     
     <td>return</td>
     <td>super</td>
     <td>switch</td>
     <td>static</td>
     <td>this</td>
     <td>throw</td>
     <td>true</td>
     <td>typeof</td>
   </tr>

   <tr>
     
     <td>var</td>
     <td>void</td>
     <td>while</td>
     <td>with</td>
     <td>yield</td>
    
   </tr>

  

 </tbody>
</Table>
  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/javascript-variables">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-comment">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Ckeyword;